var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
export var LegacyDialogEnum;
(function (LegacyDialogEnum) {
    LegacyDialogEnum["UpgradeSubscription"] = "/legacy/upgrade-human.html";
    LegacyDialogEnum["BuySubscription"] = "/legacy/buy-subscription.html";
    LegacyDialogEnum["MyProfile"] = "/legacy/user-account.html";
})(LegacyDialogEnum || (LegacyDialogEnum = {}));
var LegacyDialogComponent = /** @class */ (function () {
    function LegacyDialogComponent(dialogRef, data, sanitizer) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.sanitizer = sanitizer;
        this.headerOffset = 100;
        this.settings = {
            type: null,
            dimensions: {
                width: 100,
                height: 100
            }
        };
        this.settings = __assign({}, this.settings, data);
        var _a = data.dimensions, width = _a.width, height = _a.height;
        // size modal
        this.dialogRef.updateSize(width + "px", height + "px");
    }
    Object.defineProperty(LegacyDialogComponent.prototype, "height", {
        get: function () {
            var height = this.settings.dimensions.height;
            var targetHeight = height - this.headerOffset;
            return Math.max(200, targetHeight);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LegacyDialogComponent.prototype, "src", {
        get: function () {
            var url = this.getURL();
            if (url) {
                return this.sanitizer.bypassSecurityTrustResourceUrl(url);
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    LegacyDialogComponent.prototype.ngOnInit = function () {
    };
    LegacyDialogComponent.prototype.closeDialog = function () {
        this.dialogRef.close();
    };
    // get modal url
    LegacyDialogComponent.prototype.getURL = function () {
        var url = "" + this.settings.type;
        var valid = Object.values(LegacyDialogEnum).includes(url);
        if (valid) {
            var urlParams = this.getURLParams();
            if (urlParams) {
                return url + "?" + urlParams;
            }
            else {
                return url;
            }
        }
        else {
            return '';
        }
    };
    // get optional url params
    LegacyDialogComponent.prototype.getURLParams = function () {
        var options = this.settings.options;
        if (options) {
            return Object.entries(options)
                .map(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                return key + "=" + value;
            })
                .join('&');
        }
        else {
            return '';
        }
    };
    return LegacyDialogComponent;
}());
export { LegacyDialogComponent };
